import React , { useState,useEffect }from 'react'
import { Button,  Form, Input,Checkbox } from 'antd';
import { UserOutlined,LockOutlined } from '@ant-design/icons';
import './styles.css';
import './login.css';
import {getApiData} from "../../request/api";
import checkLogin from '../../request/checkLogin.js'
// import { useNavigate } from 'react-router-dom';
// import CryptoJS from 'crypto-js';
import { encrypt,decrypt,localStorageSet,localStorageGet } from '../../utils/global.js';

// const navigate = useNavigate();
  // navigate(-1)//适用于返回上级页面
  // navigate('/router');//也可直接加路径

const scrheight = document.body.clientHeight;
var PathBASE=window.location.href;
    PathBASE = PathBASE.split("#/")[0]; 

const Login =(props)=>{
    const [form] = Form.useForm();
    const [bChecked,setChecked] = useState(false);

    const token = localStorage.getItem('token');
    var currentUserinfo = localStorageGet('UserInfo');
    console.log("currentUserinfo---------", currentUserinfo);
  
    if(token && currentUserinfo){
      window.location.href=PathBASE+'#/admin/dashboard';
    }
  

    useEffect(() => {
      var localLoginfo = localStorageGet('loginfo');
      // console.log('localLoginfo:----------- ', localLoginfo);
      if(localLoginfo){
        var loginfo_ = JSON.parse(decrypt(localLoginfo));
        // console.log('loginfo_--------------', loginfo_)
        form.setFieldValue('account', loginfo_.account);
        form.setFieldValue('passwd', loginfo_.passwd);
        setChecked(true);
      }
      else{
        setTimeout(()=>{
          form.setFieldValue('account', "");
          form.setFieldValue('passwd', "");
          setChecked(false);

        }, 100)
      }
    }, []);
    
    const onChange = (e) => {
      setChecked(e.target.checked);
    };

    const onFinish = async(value)=>{
        // console.log(value);
        // console.log(bChecked);
        localStorage.removeItem('token');

        if(bChecked){
          localStorageSet("loginfo", encrypt(JSON.stringify({"account":value.account, "passwd":value.passwd})));
        }
        else{
          localStorage.removeItem("loginfo");
        }
        try {
            return await getApiData('A', 'A_login', value).then((res) => {
              console.log('A_login-res-----------------', res);
              var flag = checkLogin('A', res.data)
              if (flag) {
                localStorage.setItem('token',res.data.d.token);
                localStorageSet("UserInfo", {id:res.data.d.uid, account:value.account});
                window.location.href=PathBASE+'#/admin/dashboard';
                // props.history.push({
                //     pathname: '/admin',
                //   });
              }
            });
          } catch (error) {
            
            return false;
          }
    }
  return (
    <div className='loginbg' style={{height:"100vh", display:"flex", justifyContent:"center", alignItems:"center"}}>
    <div  id="box" className='container' style={{maxWidth:500}} >
        <div style={{background:"white",boxShadow:" 0 0 10px rgba(0, 0, 0, 0.1)", borderRadius:3, overflow:'hidden',padding:"30px 5px 10px"}}>
          <img src={[require("../../img/TopDigitalLogo.png")]} alt="" width="70%" />
            {/* <img src={[require("../../img/tbilogo.png")]} alt="" width="80%" /> */}
            <Form form={form}
            className='loginForm'
            name="normal_login"
            // labelCol={{span: 5}}
            // wrapperCol={{span: 16}}
            onFinish={onFinish}
            layout="vertical"
            // onFinishFailed={this.onFinishFailed}
            autoComplete="off"
        >
            <Form.Item
                // label="账号"
                name="account"
                // className='normal_input'
                rules={[
                  {required: true, message: '请输入用户名',},
                  // {pattern: /^1\d{10}$/, message: '手机号格式错误'},

                  // {max: 12,message: '用户名最多12位',},
                  // {min: 3,message: '用户名至少3位',},
                  // {pattern:/^[a-zA-Z0-9_]+$/,message: '用户名必须是英文、字母或下划线',},

                    // {
                    // required: true,
                    // message: '请输入您的手机号！',
                    // },
                ]}
            >
            <Input placeholder="用户名" addonBefore={<UserOutlined />} />
            </Form.Item>
            <Form.Item
                // label="密码"
                name="passwd"
                rules={[
                  {required: true,message: '密码必须6-30个字符',},
                  {max: 30,message: '密码最多30位',},
                  {min: 6,message: '密码至少6位',},
                  // {pattern:^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{8,16}$,message: '密码必须包含字母和数字',},
                ]}
            >
            <Input.Password  placeholder="密码" addonBefore={<LockOutlined />} />
            </Form.Item>
            <Form.Item name="bChecked" style={{textAlign:"left"}}>
            <Checkbox checked={bChecked} onChange={onChange}>记住我</Checkbox>
            </Form.Item>
            <Form.Item>
            <div>
            <Button type="primary" htmlType="submit" style={{width: "100%",height:35,borderRadius: 1,backgroundColor: "#a4080f",borderColor: "#e50012",fontSize: 15,marginTop:-10}}>
            {/* <Button type="primary" htmlType="submit" style={{width: "100%",height:35,borderRadius: 1,backgroundColor: "rgb(152,100,201)",borderColor: "rgb(152,100,201)",fontSize: 15,marginTop:-10}}> */}
                登录
            </Button>
            </div>
            </Form.Item>
        </Form>
        </div>
        </div>
    </div>
  )
}
export default Login
